// This file is auto-generated. Do not edit!

export default [
  {
    bpt: "0x00dF7f58e1Cf932eBe5f54De5970Fb2Bdf0ef06D",
    id: "0x00df7f58e1cf932ebe5f54de5970fb2bdf0ef06d00010000000000000000005b",
    name: "B-50wstETH-25BAL-25AURA",
    type: "Weighted",
    gauge: "0x64cee2356f959E78DB36A4C23a28f0454447C3dF",
    tokens: [
      {
        address: "0x1509706a6c66CA549ff0cB464de88231DDBe213B",
        symbol: "AURA",
      },
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
      {
        address: "0x7eF541E2a22058048904fE5744f9c7E4C57AF717",
        symbol: "BAL",
      },
    ],
  },
  {
    bpt: "0x013Fdedd2bD8a49D6EC9447125BF32dab2F5648e",
    id: "0x013fdedd2bd8a49d6ec9447125bf32dab2f5648e00010000000000000000004a",
    name: "33WETH-33USDC-33WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x026e352458409dB7113CDa942149C1E19693AC80",
    id: "0x026e352458409db7113cda942149c1e19693ac8000020000000000000000001f",
    name: "50WETH-50HOP",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0xc5102fE9359FD9a28f877a67E36B0F050d81a3CC",
        symbol: "HOP",
      },
    ],
  },
  {
    bpt: "0x0503Dd6b2D3Dd463c9BeF67fB5156870Af63393E",
    id: "0x0503dd6b2d3dd463c9bef67fb5156870af63393e000200000000000000000003",
    name: "wxdaiusdcweighted",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x052e3a676034fd4DDdF2Ed1242be296E54002182",
    id: "0x052e3a676034fd4dddf2ed1242be296e540021820001000000000000000000c5",
    name: "30USDC.e-10BAL-60GROSH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2a22f9c3b484c3629090FeED35F17Ff8F88f76F0",
        symbol: "USDC.e",
      },
      {
        address: "0x7eF541E2a22058048904fE5744f9c7E4C57AF717",
        symbol: "BAL",
      },
      {
        address: "0x8fEd19c7e7b59e7cfe8d0A1f570C96A721198710",
        symbol: "GROSH",
      },
    ],
  },
  {
    bpt: "0x06135A9Ae830476d3a941baE9010B63732a055F4",
    id: "0x06135a9ae830476d3a941bae9010b63732a055f4000000000000000000000065",
    name: "stEUR/EURe",
    type: "ComposableStable",
    gauge: "0x49b7C059bF0A71583918928D33C84Dcb2aa001f8",
    tokens: [
      {
        address: "0x004626A008B1aCdC4c74ab51644093b155e59A23",
        symbol: "stEUR",
      },
      {
        address: "0xcB444e90D8198415266c6a2724b7900fb12FC56E",
        symbol: "EURe",
      },
    ],
  },
  {
    bpt: "0x09d50d1CaB16BF9c69034ff15221bC3ed84df259",
    id: "0x09d50d1cab16bf9c69034ff15221bc3ed84df25900020000000000000000011e",
    name: "BFN50WBTC50",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2cabC867A6C4a32846677e74b3F75Df055E01F21",
        symbol: "s-BFN",
      },
      {
        address: "0x8e5bBbb09Ed1ebdE8674Cda39A0c169401db4252",
        symbol: "WBTC",
      },
    ],
  },
  {
    bpt: "0x0a24F8A142FEC1C3da01398d2F4DDa168443A915",
    id: "0x0a24f8a142fec1c3da01398d2f4dda168443a915000200000000000000000019",
    name: "50VITA-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0939a7c3f8D37C1ce67fAda4963aE7E0bd112ff3",
        symbol: "VITA",
      },
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x0c147051622fB6A45CcDFaA94308e3E1061091c0",
    id: "0x0c147051622fb6a45ccdfaa94308e3e1061091c00002000000000000000000c8",
    name: "GROSH-EURe",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x8fEd19c7e7b59e7cfe8d0A1f570C96A721198710",
        symbol: "GROSH",
      },
      {
        address: "0xcB444e90D8198415266c6a2724b7900fb12FC56E",
        symbol: "EURe",
      },
    ],
  },
  {
    bpt: "0x0EF212aBFec20642326a0BE06cfA5CD8f08D9B22",
    id: "0x0ef212abfec20642326a0be06cfa5cd8f08d9b22000200000000000000000084",
    name: "50sDAI-50WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x11467c3BEea894d9e8618d80b9a006C9BAa9344c",
    id: "0x11467c3beea894d9e8618d80b9a006c9baa9344c000200000000000000000018",
    name: "50FRACTION-50MIVA",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2bF2ba13735160624a0fEaE98f6aC8F70885eA61",
        symbol: "FRACTION",
      },
      {
        address: "0x63e62989D9EB2d37dfDB1F93A22f063635b07d51",
        symbol: "MIVA",
      },
    ],
  },
  {
    bpt: "0x11884dA90FB4221b3aa288a7741C51eC4Fc43B2f",
    id: "0x11884da90fb4221b3aa288a7741c51ec4fc43b2f000000000000000000000004",
    name: "xdaiusdtusdc",
    type: "Stable",
    gauge: null,
    tokens: [
      {
        address: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
        symbol: "USDT",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x1225D4e9ad9AcEB34D03473D514346D07BC04327",
    id: "0x1225d4e9ad9aceb34d03473d514346d07bc04327000200000000000000000055",
    name: "HNY-BAL",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x71850b7E9Ee3f13Ab46d67167341E4bDc905Eef9",
        symbol: "HNY",
      },
      {
        address: "0x7eF541E2a22058048904fE5744f9c7E4C57AF717",
        symbol: "BAL",
      },
    ],
  },
  {
    bpt: "0x123839D2DEc96a2ac166c9aD9921443d7BBeE39E",
    id: "0x123839d2dec96a2ac166c9ad9921443d7bbee39e00020000000000000000004d",
    name: "50WETH-50USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x1445d65aDCCe244505491Ccad8A86d161252a0de",
    id: "0x1445d65adcce244505491ccad8a86d161252a0de00020000000000000000012b",
    name: "BFN50WBTC50",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0d8c4901Dd270Fe101B8014A5dbECC4e4432eB1E",
        symbol: "s-BFN",
      },
      {
        address: "0x8e5bBbb09Ed1ebdE8674Cda39A0c169401db4252",
        symbol: "WBTC",
      },
    ],
  },
  {
    bpt: "0x15D17723BC3840f6e86Ab47819843fCD7558F410",
    id: "0x15d17723bc3840f6e86ab47819843fcd7558f41000020000000000000000003a",
    name: "50agEUR-50WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4b1E2c2762667331Bc91648052F646d1b0d35984",
        symbol: "agEUR",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x17794DB163DD298bbA1FfA4d42918C6b8474D948",
    id: "0x17794db163dd298bba1ffa4d42918c6b8474d94800020000000000000000008b",
    name: "10REG-90USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0AA1e96D2a46Ec6beB2923dE1E61Addf5F5f1dce",
        symbol: "REG",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x1e8b447129984d8A6B652C807DfC3bd135973133",
    id: "0x1e8b447129984d8a6b652c807dfc3bd1359731330002000000000000000000d6",
    name: "ECLP-GYD-sDAI",
    type: "GyroE",
    gauge: "0xEA71b7FDAA3683D2d307e8AF3e236FB7a395e88d",
    tokens: [
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
      {
        address: "0xCA5d8F8a8d49439357d3CF46Ca2e720702F132b8",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0x2086f52651837600180dE173B09470F54EF74910",
    id: "0x2086f52651837600180de173b09470f54ef7491000000000000000000000004f",
    name: "staBAL3",
    type: "ComposableStable",
    gauge: "0xaD46e3C1C55241261aFe5751384eEDCf6db6e0a8",
    tokens: [
      {
        address: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
        symbol: "USDT",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x2178eF6E2D4408CE87a1f1dA886e3023a0B57708",
    id: "0x2178ef6e2d4408ce87a1f1da886e3023a0b57708000200000000000000000119",
    name: "METESTSUP-sDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x370eb0F68CFd9f2b26B1CaCE93DC619954cb5dAF",
        symbol: "s-METESTSUP",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
  {
    bpt: "0x21cb6436ADBaB74A1F27c665B6385d46801125c8",
    id: "0x21cb6436adbab74a1f27c665b6385d46801125c800010000000000000000004e",
    name: "30WETH-20HNY-10GNO-40WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0x71850b7E9Ee3f13Ab46d67167341E4bDc905Eef9",
        symbol: "HNY",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x21d4c792Ea7E38e0D0819c2011A2b1Cb7252Bd99",
    id: "0x21d4c792ea7e38e0d0819c2011a2b1cb7252bd9900020000000000000000001e",
    name: "50COW-50GNO",
    type: "Weighted",
    gauge: "0x91151BA698253E24C23A754d94f94049a17e8084",
    tokens: [
      {
        address: "0x177127622c4A00F3d409B75571e12cB3c8973d3c",
        symbol: "COW",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
    ],
  },
  {
    bpt: "0x22D3f4E4Dada5d7a3007a58DD191897AD8578160",
    id: "0x22d3f4e4dada5d7a3007a58dd191897ad8578160000200000000000000000089",
    name: "50REG-50sDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0AA1e96D2a46Ec6beB2923dE1E61Addf5F5f1dce",
        symbol: "REG",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
  {
    bpt: "0x263A6Edafa6444DC2ae550f9EFF6344c1686d6aA",
    id: "0x263a6edafa6444dc2ae550f9eff6344c1686d6aa0002000000000000000000d5",
    name: "ECLP-GYD-AUSDC.e",
    type: "GyroE",
    gauge: "0xeCC38A7E4EB20FB72BA1cDcF2fC7A6002C6C59f3",
    tokens: [
      {
        address: "0xCA5d8F8a8d49439357d3CF46Ca2e720702F132b8",
        symbol: "GYD",
      },
      {
        address: "0xf0E7eC247b918311afa054E0AEdb99d74c31b809",
        symbol: "stataGnoUSDCe",
      },
    ],
  },
  {
    bpt: "0x274DEDB9356C3E1E24Bfe2BF3D4349fBdBFA0d14",
    id: "0x274dedb9356c3e1e24bfe2bf3d4349fbdbfa0d14000200000000000000000054",
    name: "staBAL3-GNO-BPT",
    type: "Weighted",
    gauge: "0x4489Dc0fF2a43023F2a85eFdc4614D250612dd0d",
    tokens: [
      {
        address: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
        symbol: "USDT",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
    ],
  },
  {
    bpt: "0x28535e9BbDC5F5A3095B4c999f50b7F7fe62C023",
    id: "0x28535e9bbdc5f5a3095b4c999f50b7f7fe62c0230002000000000000000000d1",
    name: "50bGME-50sDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x7212088A11b4d8f6FC90fbB3dfE793B45dd72323",
        symbol: "bGME",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
  {
    bpt: "0x2b70a38dEbCAdA7f90B88a9662024CEfd64DB29E",
    id: "0x2b70a38debcada7f90b88a9662024cefd64db29e0001000000000000000000c2",
    name: "10BAL-45GROSH-15crvUSD-15sDAI-15WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x7eF541E2a22058048904fE5744f9c7E4C57AF717",
        symbol: "BAL",
      },
      {
        address: "0x8fEd19c7e7b59e7cfe8d0A1f570C96A721198710",
        symbol: "GROSH",
      },
      {
        address: "0xaBEf652195F98A91E490f047A5006B71c85f058d",
        symbol: "crvUSD",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x2C0276F204EEBF1dae08d1C83588BA90caa9E33E",
    id: "0x2c0276f204eebf1dae08d1c83588ba90caa9e33e0002000000000000000000c3",
    name: "GROSH-GNO",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x8fEd19c7e7b59e7cfe8d0A1f570C96A721198710",
        symbol: "GROSH",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
    ],
  },
  {
    bpt: "0x2cb249540d7B84FB4A03b60383De3e968F7f20f8",
    id: "0x2cb249540d7b84fb4a03b60383de3e968f7f20f800020000000000000000002f",
    name: "50WETH-50GNO",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
    ],
  },
  {
    bpt: "0x2EF8705FFe0A116cBc6C3Eddd585096714240c8e",
    id: "0x2ef8705ffe0a116cbc6c3eddd585096714240c8e000200000000000000000083",
    name: "15NEXT-85USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x58b9cB810A68a7f3e1E4f8Cb45D1B9B3c79705E8",
        symbol: "NEXT",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x2FD74Fb2b2B79dB5F7E53061CA420087a29570Fc",
    id: "0x2fd74fb2b2b79db5f7e53061ca420087a29570fc0002000000000000000002dd",
    name: "GNOsDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
  {
    bpt: "0x31A43002E60D4B66084f4cC4E68585358c362b44",
    id: "0x31a43002e60d4b66084f4cc4e68585358c362b440002000000000000000000ce",
    name: "50bNVDA-50sDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xA34C5e0AbE843E10461E2C9586Ea03E55Dbcc495",
        symbol: "bNVDA",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
  {
    bpt: "0x327e7Fd9C7fd521305d35C513cE2E561F3C3126c",
    id: "0x327e7fd9c7fd521305d35c513ce2e561f3c3126c00010000000000000000008d",
    name: "60REG-20sDAI-20USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0AA1e96D2a46Ec6beB2923dE1E61Addf5F5f1dce",
        symbol: "REG",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x3306f9356f6645BeDd7Dc3803bd6872dFd48f058",
    id: "0x3306f9356f6645bedd7dc3803bd6872dfd48f058000200000000000000000041",
    name: "50USDC-50WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x333c19b134553Fdc75b2E252b7f56DD3ec34c1f9",
    id: "0x333c19b134553fdc75b2e252b7f56dd3ec34c1f900010000000000000000008e",
    name: "13REG-13staBAL3-13wstETH-13WBTC-13GNO-13sDAI-13OLAS-13WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0AA1e96D2a46Ec6beB2923dE1E61Addf5F5f1dce",
        symbol: "REG",
      },
      {
        address: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
        symbol: "USDT",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
      {
        address: "0x8e5bBbb09Ed1ebdE8674Cda39A0c169401db4252",
        symbol: "WBTC",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
      {
        address: "0xcE11e14225575945b8E6Dc0D4F2dD4C570f79d9f",
        symbol: "OLAS",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x35da2486F66a8B2DC305Abf4a51dF118c9984478",
    id: "0x35da2486f66a8b2dc305abf4a51df118c998447800020000000000000000001c",
    name: "BUSD-WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xdd96B45877d0E8361a4DDb732da741e97f3191Ff",
        symbol: "BUSD",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x360B4Ff22b268Af38Ced941193e48d183b924a95",
    id: "0x360b4ff22b268af38ced941193e48d183b924a9500020000000000000000007f",
    name: "50MIVA-50GNO",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x63e62989D9EB2d37dfDB1F93A22f063635b07d51",
        symbol: "MIVA",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
    ],
  },
  {
    bpt: "0x36C7C45C2ED92e28584f35F5a91a35B7B7342132",
    id: "0x36c7c45c2ed92e28584f35f5a91a35b7b734213200020000000000000000003c",
    name: "51WETH-49GNO",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
    ],
  },
  {
    bpt: "0x388Cae2f7d3704C937313d990298Ba67D70a3709",
    id: "0x388cae2f7d3704c937313d990298ba67d70a3709000200000000000000000026",
    name: "50AGVE-50GNO",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x3a97704a1b25F08aa230ae53B352e2e72ef52843",
        symbol: "AGVE",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
    ],
  },
  {
    bpt: "0x3A2E363C09a8D38E88D68630C426b394023fe5d0",
    id: "0x3a2e363c09a8d38e88d68630c426b394023fe5d0000200000000000000000092",
    name: "49WETH-51WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x3b28e683d0f7012e3194D2dbC0247D227b859B00",
    id: "0x3b28e683d0f7012e3194d2dbc0247d227b859b000002000000000000000000df",
    name: "50SAFE-50OLAS",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4d18815D14fe5c3304e87B3FA18318baa5c23820",
        symbol: "SAFE",
      },
      {
        address: "0xcE11e14225575945b8E6Dc0D4F2dD4C570f79d9f",
        symbol: "OLAS",
      },
    ],
  },
  {
    bpt: "0x3B7F9B579cb50B00bDb71672fA1a26F6EAdA9114",
    id: "0x3b7f9b579cb50b00bdb71672fa1a26f6eada91140002000000000000000000a7",
    name: "50WETH-50EURe",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0xcB444e90D8198415266c6a2724b7900fb12FC56E",
        symbol: "EURe",
      },
    ],
  },
  {
    bpt: "0x3f3df4dEeE2067e7972d436980D2887103a3ED4d",
    id: "0x3f3df4deee2067e7972d436980d2887103a3ed4d000200000000000000000052",
    name: "B-50USD-50wstETH",
    type: "Weighted",
    gauge: "0xbDcC4015eb062Ca9045E55793dCAC95cdA093a01",
    tokens: [
      {
        address: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
        symbol: "USDT",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
    ],
  },
  {
    bpt: "0x440dfa59B820e07677f4CBA29d64755Eb1c9508E",
    id: "0x440dfa59b820e07677f4cba29d64755eb1c9508e000200000000000000000095",
    name: "80WETH-20WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x442A01a7b1641Ac9C6b2B0d6D6dFf31e0A2D2e42",
    id: "0x442a01a7b1641ac9c6b2b0d6d6dff31e0a2d2e42000200000000000000000068",
    name: "50staBAL3-50crvUSD",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
        symbol: "USDT",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
      {
        address: "0xaBEf652195F98A91E490f047A5006B71c85f058d",
        symbol: "crvUSD",
      },
    ],
  },
  {
    bpt: "0x4665228B80cF5cD016277157237c40b6d7bd2c65",
    id: "0x4665228b80cf5cd016277157237c40b6d7bd2c650002000000000000000000d4",
    name: "20osGNO-80SWISE",
    type: "Weighted",
    gauge: "0x375C3e436B82BbC20D12f248C0aC4e55A11456E0",
    tokens: [
      {
        address: "0xF490c80aAE5f2616d3e3BDa2483E30C4CB21d1A0",
        symbol: "osGNO",
      },
      {
        address: "0xfdA94F056346d2320d4B5E468D6Ad099b2277746",
        symbol: "SWISE",
      },
    ],
  },
  {
    bpt: "0x4683e340a8049261057D5aB1b29C8d840E75695e",
    id: "0x4683e340a8049261057d5ab1b29c8d840e75695e00020000000000000000005a",
    name: "B-50wstETH-50GNO",
    type: "Weighted",
    gauge: "0xB812249d60b80c7Cbc9398E382eD6DFDF82E23D2",
    tokens: [
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
    ],
  },
  {
    bpt: "0x48094F85AEEb2D67D6F1EF2409d600C02859e57c",
    id: "0x48094f85aeeb2d67d6f1ef2409d600c02859e57c0002000000000000000002fc",
    name: "ECLP-GNO-USDC.e-dyn",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x2a22f9c3b484c3629090FeED35F17Ff8F88f76F0",
        symbol: "USDC.e",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
    ],
  },
  {
    bpt: "0x48a50106D9123EfaeBF5ee402f3f7E1C3Da49f27",
    id: "0x48a50106d9123efaebf5ee402f3f7e1c3da49f270001000000000000000000ba",
    name: "40REG-30sDAI-20WBTC-10wstETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0AA1e96D2a46Ec6beB2923dE1E61Addf5F5f1dce",
        symbol: "REG",
      },
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
      {
        address: "0x8e5bBbb09Ed1ebdE8674Cda39A0c169401db4252",
        symbol: "WBTC",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
  {
    bpt: "0x4bcf6b48906fA0f68bEa1FC255869A41241d4851",
    id: "0x4bcf6b48906fa0f68bea1fc255869a41241d4851000200000000000000000021",
    name: "50WXDAI-50MPS",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
      {
        address: "0xfa57AA7beED63D03Aaf85fFd1753f5f6242588fb",
        symbol: "MPS",
      },
    ],
  },
  {
    bpt: "0x4cdABE9E07ca393943AcFB9286bBbd0D0a310Ff6",
    id: "0x4cdabe9e07ca393943acfb9286bbbd0d0a310ff600020000000000000000005c",
    name: "B-50wstETH-50COW",
    type: "Weighted",
    gauge: "0xce18A3d0D928aB8883F355B5009D2de07D5C1d83",
    tokens: [
      {
        address: "0x177127622c4A00F3d409B75571e12cB3c8973d3c",
        symbol: "COW",
      },
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
    ],
  },
  {
    bpt: "0x4d7D7b769cC617A00Ed98ff3426c350A50E72712",
    id: "0x4d7d7b769cc617a00ed98ff3426c350a50e727120001000000000000000000c1",
    name: "USDC.e-USDT-BAL-GROSH-sDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2a22f9c3b484c3629090FeED35F17Ff8F88f76F0",
        symbol: "USDC.e",
      },
      {
        address: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
        symbol: "USDT",
      },
      {
        address: "0x7eF541E2a22058048904fE5744f9c7E4C57AF717",
        symbol: "BAL",
      },
      {
        address: "0x8fEd19c7e7b59e7cfe8d0A1f570C96A721198710",
        symbol: "GROSH",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
  {
    bpt: "0x50909c89B69BDaA1E07a7f23f7D2ff84197e6Fe3",
    id: "0x50909c89b69bdaa1e07a7f23f7d2ff84197e6fe3000100000000000000000098",
    name: "33GNOBBY-33GNO-33SDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x1a8805194D0eF2F73045a00c70Da399d9E74221c",
        symbol: "GNOBBY",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
  {
    bpt: "0x5237A12E9D9095CC085F2BDD4e32393993f73C15",
    id: "0x5237a12e9d9095cc085f2bdd4e32393993f73c15000200000000000000000062",
    name: "50agEUR-50EURe",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4b1E2c2762667331Bc91648052F646d1b0d35984",
        symbol: "agEUR",
      },
      {
        address: "0xcB444e90D8198415266c6a2724b7900fb12FC56E",
        symbol: "EURe",
      },
    ],
  },
  {
    bpt: "0x5519E2d8A0af0944EA639C6DBAD69A174DE3ECF8",
    id: "0x5519e2d8a0af0944ea639c6dbad69a174de3ecf800010000000000000000003b",
    name: "BAL-GNO-wstETH/WETH-WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x7eF541E2a22058048904fE5744f9c7E4C57AF717",
        symbol: "BAL",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x571aa9125A32B88C8b4B68C24FcBBfe384491786",
    id: "0x571aa9125a32b88c8b4b68c24fcbbfe384491786000200000000000000000073",
    name: "50WBTC-50WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x8e5bBbb09Ed1ebdE8674Cda39A0c169401db4252",
        symbol: "WBTC",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x5C78d05b8ECF97507d1cf70646082c54FaA4dA95",
    id: "0x5c78d05b8ecf97507d1cf70646082c54faa4da95000000000000000000000030",
    name: "bb-agEUR-EURe",
    type: "ComposableStable",
    gauge: "0x210ABdFD989f3eE5C08614a8f4e096Cf8408f5DF",
    tokens: [
      {
        address: "0x4b1E2c2762667331Bc91648052F646d1b0d35984",
        symbol: "agEUR",
      },
      {
        address: "0xcB444e90D8198415266c6a2724b7900fb12FC56E",
        symbol: "EURe",
      },
    ],
  },
  {
    bpt: "0x5DC587361652A791A4B271e635B060665A1D4ceF",
    id: "0x5dc587361652a791a4b271e635b060665a1d4cef00020000000000000000009d",
    name: "15sDAI-85SLX",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
      {
        address: "0xF4F3c1666E750E014DE65c50d0e98B1263E678B8",
        symbol: "SLX",
      },
    ],
  },
  {
    bpt: "0x65FdCD3c159845F0b33A274aAd527391cFe0583e",
    id: "0x65fdcd3c159845f0b33a274aad527391cfe0583e000200000000000000000037",
    name: "50agEUR-50BAL",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4b1E2c2762667331Bc91648052F646d1b0d35984",
        symbol: "agEUR",
      },
      {
        address: "0x7eF541E2a22058048904fE5744f9c7E4C57AF717",
        symbol: "BAL",
      },
    ],
  },
  {
    bpt: "0x66888E4F35063Ad8bb11506A6fde5024fb4f1dB0",
    id: "0x66888e4f35063ad8bb11506a6fde5024fb4f1db0000100000000000000000053",
    name: "staBAL3-WETH-WBTC-BPT",
    type: "Weighted",
    gauge: "0x9fF4e3925B88B6885083A88c2283a21CD504D3d4",
    tokens: [
      {
        address: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
        symbol: "USDT",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0x8e5bBbb09Ed1ebdE8674Cda39A0c169401db4252",
        symbol: "WBTC",
      },
    ],
  },
  {
    bpt: "0x69E1cF7C9DA9Ab008920ecE7a31AA9D83f5Ff7Ad",
    id: "0x69e1cf7c9da9ab008920ece7a31aa9d83f5ff7ad000200000000000000000069",
    name: "50crvUSD-50EURe",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xaBEf652195F98A91E490f047A5006B71c85f058d",
        symbol: "crvUSD",
      },
      {
        address: "0xcB444e90D8198415266c6a2724b7900fb12FC56E",
        symbol: "EURe",
      },
    ],
  },
  {
    bpt: "0x6A2529DEACAbaebfC28fA36338FE83f00870Cf02",
    id: "0x6a2529deacabaebfc28fa36338fe83f00870cf0200020000000000000000006e",
    name: "80AGVE-20sDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x3a97704a1b25F08aa230ae53B352e2e72ef52843",
        symbol: "AGVE",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
  {
    bpt: "0x6f4ae97d73C295D69828618Ef18bdD1BA0593DF1",
    id: "0x6f4ae97d73c295d69828618ef18bdd1ba0593df1000000000000000000000070",
    name: "STABAL4",
    type: "ComposableStable",
    gauge: null,
    tokens: [
      {
        address: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
        symbol: "USDT",
      },
      {
        address: "0xaBEf652195F98A91E490f047A5006B71c85f058d",
        symbol: "crvUSD",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x70e1ee4f63131C1E2a7c24eE0AF3396A71963641",
    id: "0x70e1ee4f63131c1e2a7c24ee0af3396a71963641000200000000000000000076",
    name: "B-50sGBP3-50GBPe",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x5Cb9073902F2035222B9749F8fB0c9BFe5527108",
        symbol: "GBPe",
      },
      {
        address: "0xcB444e90D8198415266c6a2724b7900fb12FC56E",
        symbol: "EURe",
      },
    ],
  },
  {
    bpt: "0x717633A41211C944C7808013b44824C3D9BB63cD",
    id: "0x717633a41211c944c7808013b44824c3d9bb63cd000200000000000000000116",
    name: "50WBTC/50WSTETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
      {
        address: "0x8e5bBbb09Ed1ebdE8674Cda39A0c169401db4252",
        symbol: "WBTC",
      },
    ],
  },
  {
    bpt: "0x71E1179C5e197FA551BEEC85ca2EF8693c61b85b",
    id: "0x71e1179c5e197fa551beec85ca2ef8693c61b85b0002000000000000000000a0",
    name: "ECLP-rETH-WETH",
    type: "GyroE",
    gauge: "0x25F822EB509177e393a32181182ae3981eeE6E53",
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0xc791240D1F2dEf5938E2031364Ff4ed887133C3d",
        symbol: "rETH",
      },
    ],
  },
  {
    bpt: "0x72a040c63496C9306AB3409A11Dff73176E203FD",
    id: "0x72a040c63496c9306ab3409a11dff73176e203fd00000000000000000000006a",
    name: "sBAL3/crvUSD",
    type: "ComposableStable",
    gauge: "0x4A6f50e3D0bD84c3cb2F1653F2bC8D888f5657b3",
    tokens: [
      {
        address: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
        symbol: "USDT",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
      {
        address: "0xaBEf652195F98A91E490f047A5006B71c85f058d",
        symbol: "crvUSD",
      },
    ],
  },
  {
    bpt: "0x72f9a28B95D50a66ac0f3CB008d1E932E142Cb72",
    id: "0x72f9a28b95d50a66ac0f3cb008d1e932e142cb7200010000000000000000007a",
    name: "50CRV-25crvUSD-25USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x712b3d230F3C1c19db860d80619288b1F0BDd0Bd",
        symbol: "CRV",
      },
      {
        address: "0xaBEf652195F98A91E490f047A5006B71c85f058d",
        symbol: "crvUSD",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x739607cb81f559dC52f6a9e054A89c572E5b2BAf",
    id: "0x739607cb81f559dc52f6a9e054a89c572e5b2baf00020000000000000000007b",
    name: "50COW-50wstETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x177127622c4A00F3d409B75571e12cB3c8973d3c",
        symbol: "COW",
      },
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
    ],
  },
  {
    bpt: "0x7644fA5D0eA14FcF3E813Fdf93ca9544f8567655",
    id: "0x7644fa5d0ea14fcf3e813fdf93ca9544f8567655000000000000000000000066",
    name: "sBAL3",
    type: "ComposableStable",
    gauge: "0xDec0362b3229690fBe4f88c57472610588Bb9A2E",
    tokens: [
      {
        address: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
        symbol: "USDT",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x77672c8c5c91976d79785661F7BFf7281eE529Ca",
    id: "0x77672c8c5c91976d79785661f7bff7281ee529ca000200000000000000000039",
    name: "50WETH-50WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x77E5bf699db38C578B2982c3E262E9c5F1f50Fd0",
    id: "0x77e5bf699db38c578b2982c3e262e9c5f1f50fd0000200000000000000000061",
    name: "B-50USD-50bIBTA",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
        symbol: "USDT",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
      {
        address: "0x52d134c6DB5889FaD3542A09eAf7Aa90C0fdf9E4",
        symbol: "bIBTA",
      },
    ],
  },
  {
    bpt: "0x794b2633De8F8B2AC008B8F780A26fdfE0094CA0",
    id: "0x794b2633de8f8b2ac008b8f780a26fdfe0094ca000020000000000000000008f",
    name: "50GNO-50GNOBBY",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
      {
        address: "0xd78544e8270AcE4Ba28fB69Fc1c12931d6f5d69e",
        symbol: "GNOBBY",
      },
    ],
  },
  {
    bpt: "0x79C872Ed3Acb3fc5770dd8a0cD9Cd5dB3B3Ac985",
    id: "0x79c872ed3acb3fc5770dd8a0cd9cd5db3b3ac985000200000000000000000067",
    name: "50OLAS-50WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xcE11e14225575945b8E6Dc0D4F2dD4C570f79d9f",
        symbol: "OLAS",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x7b2928DF0BfdC08Fa7d48766327a50B311742A3b",
    id: "0x7b2928df0bfdc08fa7d48766327a50b311742a3b0002000000000000000000d0",
    name: "50bMSTR-50sDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xaC28C9178ACc8BA4A11A29E013a3A2627086e422",
        symbol: "bMSTR",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
  {
    bpt: "0x7bCC01Ba7242E73CB5c93B29CbAAc22FBa44b6b3",
    id: "0x7bcc01ba7242e73cb5c93b29cbaac22fba44b6b30002000000000000000000a8",
    name: "50USDT-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
        symbol: "USDT",
      },
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x7CAEf9e452CE161dEC936ace7eab571d1023B209",
    id: "0x7caef9e452ce161dec936ace7eab571d1023b20900020000000000000000005d",
    name: "B-50wstETH-50NEXT",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x58b9cB810A68a7f3e1E4f8Cb45D1B9B3c79705E8",
        symbol: "NEXT",
      },
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
    ],
  },
  {
    bpt: "0x7D6947ec2c1d9aD65550Ac977Fe29b75FFb9A5Ce",
    id: "0x7d6947ec2c1d9ad65550ac977fe29b75ffb9a5ce000200000000000000000086",
    name: "BTC_to_MPS_and_back",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x8e5bBbb09Ed1ebdE8674Cda39A0c169401db4252",
        symbol: "WBTC",
      },
      {
        address: "0xfa57AA7beED63D03Aaf85fFd1753f5f6242588fb",
        symbol: "MPS",
      },
    ],
  },
  {
    bpt: "0x7DcfD0fE4493611eE9549b06ded97e4f22d938c2",
    id: "0x7dcfd0fe4493611ee9549b06ded97e4f22d938c2000200000000000000000058",
    name: "B-50wstETH-50COW",
    type: "Weighted",
    gauge: "0x8458c89D7334c638c00F9415A5DB9172235c236c",
    tokens: [
      {
        address: "0x177127622c4A00F3d409B75571e12cB3c8973d3c",
        symbol: "COW",
      },
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
    ],
  },
  {
    bpt: "0x7E7419eBef7171C84409B7A1C3a5D4538c98d4a1",
    id: "0x7e7419ebef7171c84409b7a1c3a5d4538c98d4a10002000000000000000000de",
    name: "ECLP-GYD-sDAI",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
      {
        address: "0xCA5d8F8a8d49439357d3CF46Ca2e720702F132b8",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0x7F96d8a3D850f0C19F6263bE0250925529aB6e2F",
    id: "0x7f96d8a3d850f0c19f6263be0250925529ab6e2f000200000000000000000075",
    name: "B-50sGBP3-50GBPe",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x5Cb9073902F2035222B9749F8fB0c9BFe5527108",
        symbol: "GBPe",
      },
      {
        address: "0xcB444e90D8198415266c6a2724b7900fb12FC56E",
        symbol: "EURe",
      },
    ],
  },
  {
    bpt: "0x8189c4c96826D016A99986394103DFa9aE41e7ee",
    id: "0x8189c4c96826d016a99986394103dfa9ae41e7ee0002000000000000000000aa",
    name: "WXDAI-GNO",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x81A22596001F64D4ecDd0f6Cd2793D1dACF7DfB3",
    id: "0x81a22596001f64d4ecdd0f6cd2793d1dacf7dfb300020000000000000000006f",
    name: "50AGVE-50sDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x3a97704a1b25F08aa230ae53B352e2e72ef52843",
        symbol: "AGVE",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
  {
    bpt: "0x8264b90052f7c6104b49f71d921344dDF93867a2",
    id: "0x8264b90052f7c6104b49f71d921344ddf93867a20001000000000000000000c9",
    name: "AURA-BAL-GROSH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x1509706a6c66CA549ff0cB464de88231DDBe213B",
        symbol: "AURA",
      },
      {
        address: "0x7eF541E2a22058048904fE5744f9c7E4C57AF717",
        symbol: "BAL",
      },
      {
        address: "0x8fEd19c7e7b59e7cfe8d0A1f570C96A721198710",
        symbol: "GROSH",
      },
    ],
  },
  {
    bpt: "0x84BB71A70685BD3F129314370431a2965E349380",
    id: "0x84bb71a70685bd3f129314370431a2965e3493800001000000000000000000c4",
    name: "33USDT-33USDC-33WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
        symbol: "USDT",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x85BcD9f8e69090ca516d5b418D9C821f4e91eCae",
    id: "0x85bcd9f8e69090ca516d5b418d9c821f4e91ecae000200000000000000000016",
    name: "50BAL-50GNO",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x7eF541E2a22058048904fE5744f9c7E4C57AF717",
        symbol: "BAL",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
    ],
  },
  {
    bpt: "0x864f76EabE542b0a83D09257AfaD59aD6f4eEdC3",
    id: "0x864f76eabe542b0a83d09257afad59ad6f4eedc3000200000000000000000017",
    name: "20WETH-80BAL",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0x7eF541E2a22058048904fE5744f9c7E4C57AF717",
        symbol: "BAL",
      },
    ],
  },
  {
    bpt: "0x86d616cD0499451045e0add700f2F223a836097B",
    id: "0x86d616cd0499451045e0add700f2f223a836097b000200000000000000000031",
    name: "50WETH-50GNO",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
    ],
  },
  {
    bpt: "0x8DD4df4Ce580b9644437f3375e54f1ab09808228",
    id: "0x8dd4df4ce580b9644437f3375e54f1ab0980822800020000000000000000009c",
    name: "ECLP-wstETH-WETH",
    type: "GyroE",
    gauge: "0xa1fF1e44E4f8346398767f94ae7DbeAB71522164",
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
    ],
  },
  {
    bpt: "0x8F5f9554fd1AeE851b6f69D0863Bb0F48c2A8402",
    id: "0x8f5f9554fd1aee851b6f69d0863bb0f48c2a840200020000000000000000012c",
    name: "METESTSUP33sDAI67",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x7147A7405fCFe5CFa30c6d5363f9f357a317d082",
        symbol: "s-METESTSUP",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
  {
    bpt: "0x8fCAdfDfe786c6f8E1cf82fbD1bD243501a18341",
    id: "0x8fcadfdfe786c6f8e1cf82fbd1bd243501a183410001000000000000000000ae",
    name: "50COW-25USDC-25WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x177127622c4A00F3d409B75571e12cB3c8973d3c",
        symbol: "COW",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x901a2d7e3267674DBD16775f6883c750e155a718",
    id: "0x901a2d7e3267674dbd16775f6883c750e155a718000200000000000000000085",
    name: "50CRV-50crvUSD",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x712b3d230F3C1c19db860d80619288b1F0BDd0Bd",
        symbol: "CRV",
      },
      {
        address: "0xaBEf652195F98A91E490f047A5006B71c85f058d",
        symbol: "crvUSD",
      },
    ],
  },
  {
    bpt: "0x915148cdE625618E91B76edc7a20F00f12dfC4c1",
    id: "0x915148cde625618e91b76edc7a20f00f12dfc4c1000200000000000000000047",
    name: "5XOC-95USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xa411c9Aa00E020e4f88Bc19996d29c5B7ADB4ACf",
        symbol: "XOC",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x915938ff0A2B54e575068fF1A95007caFBa7D277",
    id: "0x915938ff0a2b54e575068ff1a95007cafba7d27700020000000000000000008a",
    name: "80REG-20WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0AA1e96D2a46Ec6beB2923dE1E61Addf5F5f1dce",
        symbol: "REG",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x92A3bE6cE4CD693AF08756fD71Ee23BB60A97c61",
    id: "0x92a3be6ce4cd693af08756fd71ee23bb60a97c61000200000000000000000074",
    name: "50GNO-50WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x93b016A688D198d88821B4bEE5C4AFC5E6fa76C7",
    id: "0x93b016a688d198d88821b4bee5c4afc5e6fa76c70002000000000000000000a1",
    name: "",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xdBF3Ea6F5beE45c02255B2c26a16F300502F68da",
        symbol: "BZZ",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0x95a2E3F73CDCEF576a7D9B9e0D11eFb5dF90F166",
    id: "0x95a2e3f73cdcef576a7d9b9e0d11efb5df90f166000200000000000000000088",
    name: "80REG-20GNO",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0AA1e96D2a46Ec6beB2923dE1E61Addf5F5f1dce",
        symbol: "REG",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
    ],
  },
  {
    bpt: "0x992d07DEd155239F64aDBB798c7A1b9E90b834E0",
    id: "0x992d07ded155239f64adbb798c7a1b9e90b834e00001000000000000000000c6",
    name: "30USDT-10BAL-60GROSH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
        symbol: "USDT",
      },
      {
        address: "0x7eF541E2a22058048904fE5744f9c7E4C57AF717",
        symbol: "BAL",
      },
      {
        address: "0x8fEd19c7e7b59e7cfe8d0A1f570C96A721198710",
        symbol: "GROSH",
      },
    ],
  },
  {
    bpt: "0x9a4a5Ee55898900c1805bF11577b6E82B085F9f9",
    id: "0x9a4a5ee55898900c1805bf11577b6e82b085f9f900020000000000000000005f",
    name: "B-50USD-50bBTA",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
        symbol: "USDT",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
      {
        address: "0x52d134c6DB5889FaD3542A09eAf7Aa90C0fdf9E4",
        symbol: "bIBTA",
      },
    ],
  },
  {
    bpt: "0xa515361B6a769E82F6D2f3F4596AF6553FA30B84",
    id: "0xa515361b6a769e82f6d2f3f4596af6553fa30b840002000000000000000000b5",
    name: "90REG-10USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0AA1e96D2a46Ec6beB2923dE1E61Addf5F5f1dce",
        symbol: "REG",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0xA59D6eC93B050Bb755DDC9723aD577AFf48D46d6",
    id: "0xa59d6ec93b050bb755ddc9723ad577aff48d46d60001000000000000000000c0",
    name: "BAL-GROSH-WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x7eF541E2a22058048904fE5744f9c7E4C57AF717",
        symbol: "BAL",
      },
      {
        address: "0x8fEd19c7e7b59e7cfe8d0A1f570C96A721198710",
        symbol: "GROSH",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0xa621C2996c910Ab06C3ED0aa689e12B856472405",
    id: "0xa621c2996c910ab06c3ed0aa689e12b856472405000200000000000000000081",
    name: "50sDAI-50WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0xa94A92fC2cA0601481d5DE357489ceaEBa1C1Dc6",
    id: "0xa94a92fc2ca0601481d5de357489ceaeba1c1dc6000200000000000000000005",
    name: "wxdaiusdcweighted",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0xa99FD9950B5D5dCeEaf4939E221dcA8cA9B938aB",
    id: "0xa99fd9950b5d5dceeaf4939e221dca8ca9b938ab000100000000000000000025",
    name: "25WETH-25BAL-25GNO-25wxDAI",
    type: "Weighted",
    gauge: "0xC092E0a4f5a2AdF3CF91E27cf4B7d7917D12CA2B",
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0x7eF541E2a22058048904fE5744f9c7E4C57AF717",
        symbol: "BAL",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0xa9B2234773cc6A4F3A34A770C52c931CbA5C24B2",
    id: "0xa9b2234773cc6a4f3a34a770c52c931cba5c24b2000200000000000000000087",
    name: "50SAFE-50GNO",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4d18815D14fe5c3304e87B3FA18318baa5c23820",
        symbol: "SAFE",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
    ],
  },
  {
    bpt: "0xaa56989Be5E6267fC579919576948DB3e1F10807",
    id: "0xaa56989be5e6267fc579919576948db3e1f108070002000000000000000000ca",
    name: "ECLP-sDAI-USDC.e-rh",
    type: "GyroE",
    gauge: "0x9ED250d67c4E5F5B2b5F982a678eD1c0ba011207",
    tokens: [
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
      {
        address: "0xf0E7eC247b918311afa054E0AEdb99d74c31b809",
        symbol: "stataGnoUSDCe",
      },
    ],
  },
  {
    bpt: "0xAd5FB05B2adE70B046e4Cf2B5dAF731e44347E4f",
    id: "0xad5fb05b2ade70b046e4cf2b5daf731e44347e4f000100000000000000000057",
    name: "B-50wstETH-25BAL-25AURA",
    type: "Weighted",
    gauge: "0x5508D8872E91854D7C6056Bc70e9eB5ed1443464",
    tokens: [
      {
        address: "0x1509706a6c66CA549ff0cB464de88231DDBe213B",
        symbol: "AURA",
      },
      {
        address: "0x7eF541E2a22058048904fE5744f9c7E4C57AF717",
        symbol: "BAL",
      },
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
    ],
  },
  {
    bpt: "0xADF65e3DA99f7D1EfE7c5deA899ABeC9720139D0",
    id: "0xadf65e3da99f7d1efe7c5dea899abec9720139d00002000000000000000000cd",
    name: "50sDAI-50bCOIN",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
      {
        address: "0xbbcb0356bB9e6B3Faa5CbF9E5F36185d53403Ac9",
        symbol: "bCOIN",
      },
    ],
  },
  {
    bpt: "0xAE2a38545167Be5A2EBa9B931B28DE5A7d95315e",
    id: "0xae2a38545167be5a2eba9b931b28de5a7d95315e0002000000000000000000cc",
    name: "50bCSPX-50sDAI",
    type: "Weighted",
    gauge: "0xF81c47609E19B1456dDC6acb730F8F5b64840429",
    tokens: [
      {
        address: "0x1e2C4fb7eDE391d116E6B41cD0608260e8801D59",
        symbol: "bCSPX",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
  {
    bpt: "0xB8bB1ce9C6E5401D66fE2126dB6E7387E1E24fFE",
    id: "0xb8bb1ce9c6e5401d66fe2126db6e7387e1e24ffe00020000000000000000003d",
    name: "50WETH-50GNO",
    type: "Weighted",
    gauge: "0xd264f4d4Ad98FEf4b198547059C07a8E8bBF2F0E",
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
    ],
  },
  {
    bpt: "0xbAd20c15A773bf03ab973302F61FAbceA5101f0A",
    id: "0xbad20c15a773bf03ab973302f61fabcea5101f0a000000000000000000000034",
    name: "bb-WETH-wstETH",
    type: "ComposableStable",
    gauge: "0x27519F69b2Ac912aeb6fE066180FB25a17c71755",
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
    ],
  },
  {
    bpt: "0xBc130c4989E10941142b34F054Eb38D69FdCe9dF",
    id: "0xbc130c4989e10941142b34f054eb38d69fdce9df000200000000000000000049",
    name: "20XOC-80USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xa411c9Aa00E020e4f88Bc19996d29c5B7ADB4ACf",
        symbol: "XOC",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0xBc2acf5E821c5c9f8667A36bB1131dAd26Ed64F9",
    id: "0xbc2acf5e821c5c9f8667a36bb1131dad26ed64f9000200000000000000000063",
    name: "B-50sDAI-50wstETH",
    type: "Weighted",
    gauge: "0x4d13d387f372dbe5125B7d78E75094ac85B31eDc",
    tokens: [
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
  {
    bpt: "0xBEa652AA29D38114e9D36F2A2E4167b13DF68e73",
    id: "0xbea652aa29d38114e9d36f2a2e4167b13df68e73000200000000000000000006",
    name: "40USDC-60WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0xc2E5Bb9902290165e9Bc8D314881389d6Ae4B75f",
    id: "0xc2e5bb9902290165e9bc8d314881389d6ae4b75f0001000000000000000000bf",
    name: "BAL-GROSH-crvUSD",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x7eF541E2a22058048904fE5744f9c7E4C57AF717",
        symbol: "BAL",
      },
      {
        address: "0x8fEd19c7e7b59e7cfe8d0A1f570C96A721198710",
        symbol: "GROSH",
      },
      {
        address: "0xaBEf652195F98A91E490f047A5006B71c85f058d",
        symbol: "crvUSD",
      },
    ],
  },
  {
    bpt: "0xC5Df11757F4A8DFACcC731d13b9577f67055c6c6",
    id: "0xc5df11757f4a8dfaccc731d13b9577f67055c6c6000200000000000000000077",
    name: "B-50EURe-50GBPe",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x5Cb9073902F2035222B9749F8fB0c9BFe5527108",
        symbol: "GBPe",
      },
      {
        address: "0xcB444e90D8198415266c6a2724b7900fb12FC56E",
        symbol: "EURe",
      },
    ],
  },
  {
    bpt: "0xc9Ca1a35A3ABB3607a91B4362923dF9CD2C0E8e0",
    id: "0xc9ca1a35a3abb3607a91b4362923df9cd2c0e8e00001000000000000000000be",
    name: "BAL-GROSH-sDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x7eF541E2a22058048904fE5744f9c7E4C57AF717",
        symbol: "BAL",
      },
      {
        address: "0x8fEd19c7e7b59e7cfe8d0A1f570C96A721198710",
        symbol: "GROSH",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
  {
    bpt: "0xc9F00C3a713008DDf69b768d90d4978549bFDF94",
    id: "0xc9f00c3a713008ddf69b768d90d4978549bfdf9400000000000000000000006d",
    name: "crvUSD/sDAI",
    type: "ComposableStable",
    gauge: "0xB079bD76dD9b5F9a8d3954E4250FC25BE0549Ac0",
    tokens: [
      {
        address: "0xaBEf652195F98A91E490f047A5006B71c85f058d",
        symbol: "crvUSD",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
  {
    bpt: "0xCb3adCf147Da57C4e129c5bD34Ab0429501454E5",
    id: "0xcb3adcf147da57c4e129c5bd34ab0429501454e50002000000000000000000cf",
    name: "50bTSLA-50sDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x14A5f2872396802C3Cc8942A39Ab3E4118EE5038",
        symbol: "bTSLA",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
  {
    bpt: "0xcDb3863FAe60fe9feE4d62820E9002f924644332",
    id: "0xcdb3863fae60fe9fee4d62820e9002f924644332000200000000000000000093",
    name: "51WETH-49WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0xCe527b9f739c4bECdd05B416FFa70470A7Eec565",
    id: "0xce527b9f739c4becdd05b416ffa70470a7eec565000200000000000000000051",
    name: "50agEUR-50USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4b1E2c2762667331Bc91648052F646d1b0d35984",
        symbol: "agEUR",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0xD07748006D338Ac12b8Aa60D27f8645481461914",
    id: "0xd07748006d338ac12b8aa60d27f8645481461914000200000000000000000094",
    name: "55WETH-45WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0xD19eC5133d567F9611Ad61E902c821742699275f",
    id: "0xd19ec5133d567f9611ad61e902c821742699275f00020000000000000000011d",
    name: "s-TEST-LBP01",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x1a5a62AE01EaD54e2Ead4F58d9B24643AeDc5C90",
        symbol: "s-TEST-LBP01",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
  {
    bpt: "0xD37B12e79958FC7DCC9245fceA73e233C9C635e6",
    id: "0xd37b12e79958fc7dcc9245fcea73e233c9c635e60002000000000000000000c7",
    name: "wstETH-GROSH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
      {
        address: "0x8fEd19c7e7b59e7cfe8d0A1f570C96A721198710",
        symbol: "GROSH",
      },
    ],
  },
  {
    bpt: "0xdccAa73705dC7457bcfb3dAFEe529B30920e3008",
    id: "0xdccaa73705dc7457bcfb3dafee529b30920e300800020000000000000000009a",
    name: "50GIV-50GNO",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4f4F9b8D5B4d0Dc10506e5551B0513B61fD59e75",
        symbol: "GIV",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
    ],
  },
  {
    bpt: "0xDd439304A77f54B1F7854751Ac1169b279591Ef7",
    id: "0xdd439304a77f54b1f7854751ac1169b279591ef7000000000000000000000064",
    name: "EURe/sDAI",
    type: "ComposableStable",
    gauge: "0xBB2598b89202596A743BE0b615001D7D5164f167",
    tokens: [
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
      {
        address: "0xcB444e90D8198415266c6a2724b7900fb12FC56E",
        symbol: "EURe",
      },
    ],
  },
  {
    bpt: "0xddaFa272b737c387aB1a677F35aD05609Ef072bB",
    id: "0xddafa272b737c387ab1a677f35ad05609ef072bb000200000000000000000082",
    name: "20GNO-80OLAS",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
      {
        address: "0xcE11e14225575945b8E6Dc0D4F2dD4C570f79d9f",
        symbol: "OLAS",
      },
    ],
  },
  {
    bpt: "0xDfE4F5b252B24784805343983C588C657741D408",
    id: "0xdfe4f5b252b24784805343983c588c657741d408000200000000000000000033",
    name: "50WETH-50GNO",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
    ],
  },
  {
    bpt: "0xe2343512dcF8a23d81E6cdc2Fac656Db1FF83aA1",
    id: "0xe2343512dcf8a23d81e6cdc2fac656db1ff83aa100020000000000000000009b",
    name: "50WBTC-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0x8e5bBbb09Ed1ebdE8674Cda39A0c169401db4252",
        symbol: "WBTC",
      },
    ],
  },
  {
    bpt: "0xe42EBbd354D9aaD787E7730064187aCabe4317Ad",
    id: "0xe42ebbd354d9aad787e7730064187acabe4317ad00020000000000000000007d",
    name: "50MIVA-50sDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x63e62989D9EB2d37dfDB1F93A22f063635b07d51",
        symbol: "MIVA",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
  {
    bpt: "0xe45e5DbdF602e15810Cd254a2b6EA38e3dCf46Bb",
    id: "0xe45e5dbdf602e15810cd254a2b6ea38e3dcf46bb000200000000000000000048",
    name: "5XOC-95USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xa411c9Aa00E020e4f88Bc19996d29c5B7ADB4ACf",
        symbol: "XOC",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0xe6098b5511B36134717e678658A658104A7f70F0",
    id: "0xe6098b5511b36134717e678658a658104a7f70f000020000000000000000006b",
    name: "EURe/crvUSD",
    type: "Weighted",
    gauge: "0x386885D879B0c2b9a4573800267D6146Ee5A1839",
    tokens: [
      {
        address: "0xaBEf652195F98A91E490f047A5006B71c85f058d",
        symbol: "crvUSD",
      },
      {
        address: "0xcB444e90D8198415266c6a2724b7900fb12FC56E",
        symbol: "EURe",
      },
    ],
  },
  {
    bpt: "0xe85EB550e98Ee66D19c667DE24c5C8E10Fee6504",
    id: "0xe85eb550e98ee66d19c667de24c5c8e10fee6504000200000000000000000060",
    name: "B-50USD-50bCSPX",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x1e2C4fb7eDE391d116E6B41cD0608260e8801D59",
        symbol: "bCSPX",
      },
      {
        address: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
        symbol: "USDT",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0xe89023C28eB5F7079f88A284546DEc8fb8C3Cd02",
    id: "0xe89023c28eb5f7079f88a284546dec8fb8c3cd02000200000000000000000144",
    name: "s-ZUCRCW66sDAIW33",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
      {
        address: "0xE6863166D96a6f2fc2e9118AC418796f694cCFBd",
        symbol: "s-ZUCRC",
      },
    ],
  },
  {
    bpt: "0xEA54604e7E1DdEc8320cF838CFE857FbF44Aad9f",
    id: "0xea54604e7e1ddec8320cf838cfe857fbf44aad9f000200000000000000000078",
    name: "B-50GBPe-50WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x5Cb9073902F2035222B9749F8fB0c9BFe5527108",
        symbol: "GBPe",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0xeAe5E24b40343F475676241FDE1A86041f212084",
    id: "0xeae5e24b40343f475676241fde1a86041f212084000200000000000000000056",
    name: "Balancer 50wstETH-50GNO ",
    type: "Weighted",
    gauge: "0x28bD9FB97da30B04c3C679ade946319D2E91b4fd",
    tokens: [
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
    ],
  },
  {
    bpt: "0xEb30C85CC528537f5350CF5684Ce6a4538e13394",
    id: "0xeb30c85cc528537f5350cf5684ce6a4538e13394000200000000000000000059",
    name: "B-50USD-50wstETH",
    type: "Weighted",
    gauge: "0xef23C2Ec60A1ea3Ed6a44681Fb72356cB411177e",
    tokens: [
      {
        address: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
        symbol: "USDT",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
    ],
  },
  {
    bpt: "0xeD8E0EB46598a6823261F49cF116bb3D16a68B21",
    id: "0xed8e0eb46598a6823261f49cf116bb3d16a68b210002000000000000000000e4",
    name: "50mockWXDAI-50baseToken",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xab01D10C10441C78bDB839312C08dADc2C37981A",
        symbol: "WXDAI",
      },
      {
        address: "0xE377328DFe4B44EDEE119913e04aa4F076876131",
        symbol: "BASE",
      },
    ],
  },
  {
    bpt: "0xeE0E7B0d82Da252a30aEcCEdeF6840D6275FFC43",
    id: "0xee0e7b0d82da252a30aeccedef6840d6275ffc43000100000000000000000099",
    name: "33GNOBBY-33GNO-33sDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x1a8805194D0eF2F73045a00c70Da399d9E74221c",
        symbol: "GNOBBY",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
  {
    bpt: "0xF11AD03bbE64A493482C9A263995a6bec4343D6b",
    id: "0xf11ad03bbe64a493482c9a263995a6bec4343d6b00020000000000000000008c",
    name: "80REG-20sDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0AA1e96D2a46Ec6beB2923dE1E61Addf5F5f1dce",
        symbol: "REG",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
  {
    bpt: "0xf6bFfFb47bC125564cbB6cC0e7633eb7AddaEfCe",
    id: "0xf6bfffb47bc125564cbb6cc0e7633eb7addaefce00020000000000000000005e",
    name: "B-50USD-50bIB01",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
        symbol: "USDT",
      },
      {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        symbol: "USDC",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
      {
        address: "0xCA30c93B02514f86d5C86a6e375E3A330B435Fb5",
        symbol: "bIB01",
      },
    ],
  },
  {
    bpt: "0xf94E8be09A276d2Ca75aeB02113893DC5034Bb66",
    id: "0xf94e8be09a276d2ca75aeb02113893dc5034bb66000200000000000000000079",
    name: "50USDT-50WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
        symbol: "USDT",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0xfa0017abd72BB87443c3F39b9434d357Cc1EeC27",
    id: "0xfa0017abd72bb87443c3f39b9434d357cc1eec2700010000000000000000001d",
    name: "40FRACTION-40MIVA-20GNO",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2bF2ba13735160624a0fEaE98f6aC8F70885eA61",
        symbol: "FRACTION",
      },
      {
        address: "0x63e62989D9EB2d37dfDB1F93A22f063635b07d51",
        symbol: "MIVA",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
    ],
  },
  {
    bpt: "0xFA1F69d54C472B59d0094400E3f3CF297A8a4C2b",
    id: "0xfa1f69d54c472b59d0094400e3f3cf297a8a4c2b000200000000000000000096",
    name: "20WETH-80WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0xfbc3112172bA256454047D7436d1E08B3cdc5031",
    id: "0xfbc3112172ba256454047d7436d1e08b3cdc5031000200000000000000000015",
    name: "80MIVA-20WXDAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x63e62989D9EB2d37dfDB1F93A22f063635b07d51",
        symbol: "MIVA",
      },
      {
        address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
        symbol: "WXDAI",
      },
    ],
  },
  {
    bpt: "0xFed80d133fb70101dcb69c5a0598d31127e564C2",
    id: "0xfed80d133fb70101dcb69c5a0598d31127e564c20002000000000000000000cb",
    name: "50sDAI-50bIB01",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
      {
        address: "0xCA30c93B02514f86d5C86a6e375E3A330B435Fb5",
        symbol: "bIB01",
      },
    ],
  },
  {
    bpt: "0x3220C83e953186f2B9dDFc0B5dD69483354EDCA2",
    id: "0x3220c83e953186f2b9ddfc0b5dd69483354edca20000000000000000000000b0",
    name: "osGNO/GNO-BPT",
    type: "ComposableStable",
    gauge: "0x1350724a020B27c4f0E369bB00ae3127022d5465",
    tokens: [
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
      {
        address: "0xF490c80aAE5f2616d3e3BDa2483E30C4CB21d1A0",
        symbol: "osGNO",
      },
    ],
  },
  {
    bpt: "0x9D376359b1C4975Aae4907E540C76838547E2Fe2",
    id: "0x9d376359b1c4975aae4907e540c76838547e2fe20002000000000000000002fb",
    name: "ECLP-GNO-wstETH-dyn",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
    ],
  },
  {
    bpt: "0x48094F85AEEb2D67D6F1EF2409d600C02859e57c",
    id: "0x48094f85aeeb2d67d6f1ef2409d600c02859e57c0002000000000000000002fc",
    name: "ECLP-GNO-USDC.e-dyn",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x2a22f9c3b484c3629090FeED35F17Ff8F88f76F0",
        symbol: "USDC.e",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
    ],
  },
  {
    bpt: "0x9D93F38b75B376AcDFe607cD1ECF4495E047dEfF",
    id: "0x9d93f38b75b376acdfe607cd1ecf4495e047deff00000000000000000000009e",
    name: "GBPe/sDAI",
    type: "ComposableStable",
    gauge: null,
    tokens: [
      {
        address: "0x5Cb9073902F2035222B9749F8fB0c9BFe5527108",
        symbol: "GBPe",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
  },
] as const
